import React from "react";
import { REACTION_PALETTE } from "./agentChatConstants";

interface ReactionPaletteProps {
  /** toggle the current user's reaction with the picked emoji */
  onPick: (emoji: string) => void;
  /** emojis the current user has already reacted with — rendered highlighted */
  mine?: Set<string>;
}

/**
 * Compact row of quick-pick reaction emojis. Tapping one toggles the current user's reaction.
 * Used inside ReactionDetails (the chip popover) — it has no backdrop/positioning of its own.
 */
export function ReactionPicker({ onPick, mine }: ReactionPaletteProps) {
  return (
    <div role="menu" className="flex flex-wrap gap-0.5">
      {REACTION_PALETTE.map((emoji) => {
        const active = mine?.has(emoji);
        return (
          <button
            key={emoji}
            type="button"
            aria-label={`react ${emoji}`}
            aria-pressed={active}
            onClick={() => onPick(emoji)}
            className={`flex h-7 w-7 items-center justify-center rounded-full text-base leading-none transition-transform hover:scale-110 ${
              active ? "bg-sky/25 ring-1 ring-sky" : "hover:bg-gray-100"
            }`}
          >
            {emoji}
          </button>
        );
      })}
    </div>
  );
}
